
export default function processFirebaseQuery(firebaseQuery, dt) {
    return firebaseQuery.get().then((querySnapshot) => {
        let dt = [];
        querySnapshot && querySnapshot.forEach((doc) => {
            dt.push(doc.data());
        });
        return dt;
    });
}